import { useTranslations } from 'use-intl';
import { StockStatus } from '@/types/entity/product';
import { classnames } from '@/utils/classnames/classnames';
import { StockStatusTagProps } from './types';

const STATUS_TONE: Record<StockStatus, string> = {
  'in-stock': 'bg-green-100 text-green-700',
  'out-of-stock': 'bg-red-100 text-red-700',
  // EWM-545 — "Stock due soon" reuses the out-of-stock red pill.
  'due-soon': 'bg-red-100 text-red-700',
};

const StockStatusTag = ({ status, className }: StockStatusTagProps) => {
  const translate = useTranslations();

  return (
    <span
      className={classnames(
        'text-11 inline-block rounded-full px-3 py-1 font-semibold',
        STATUS_TONE[status],
        className,
      )}
    >
      {translate(`pdp.stock-${status}` as Parameters<typeof translate>[0])}
    </span>
  );
};

export default StockStatusTag;
